// extracted by mini-css-extract-plugin
module.exports = {"form":"DFARegistrationForm_form__3XzbL","progress":"DFARegistrationForm_progress__2krEp"};